import { render, staticRenderFns } from "./documentInfo.vue?vue&type=template&id=1cc878d3&scoped=true&"
import script from "./documentInfo.vue?vue&type=script&lang=js&"
export * from "./documentInfo.vue?vue&type=script&lang=js&"
import style0 from "./documentInfo.vue?vue&type=style&index=0&id=1cc878d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc878d3",
  null
  
)

export default component.exports